import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

request.interceptors.request.use(
  config => {
    // 根据当前页面路径判断使用哪个token
    // 注意：只有"真正的供应商门户"才用 supplier_token；
    // 后台的 /supplier-mgmt（供应商管理）、/supplier-evaluation（供应商考评）等
    // 虽然 hash 也以 #/supplier- 开头，但属于华府后台，必须用后台 token。
    const hash = window.location.hash
    const isSupplierPage = hash.startsWith('#/supplier-login')
      || hash.startsWith('#/supplier-register')
      || hash.startsWith('#/supplier-home')
      || window.location.pathname.startsWith('/supplier-')
    const token = isSupplierPage
      ? localStorage.getItem('supplier_token')
      : localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // JSON body -> URLSearchParams (兼容后端 @RequestParam)
    // 注意：空字符串 '' 和空数组 [] 一律不发送，否则后端用 `!= null` 判断时
    // 会把空串当成有效过滤值（eq(字段,'')），导致查不到任何数据。
    // 仅对"纯平铺简单对象"做转换；若包含嵌套对象/数组则保持 JSON（@RequestBody 接口需要）。
    if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData) && !(config.data instanceof URLSearchParams)) {
      const isFlatSimple = Object.values(config.data).every((v) => {
        return v === undefined || v === null || typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean'
      })
      if (isFlatSimple) {
        const params = new URLSearchParams()
        Object.entries(config.data).forEach(([key, value]) => {
          if (value === undefined || value === null || value === '') return
          params.append(key, String(value))
        })
        config.data = params
      } else {
        // 复杂对象（含数组/嵌套对象）走 JSON，供 @RequestBody 接口使用
        config.headers['Content-Type'] = 'application/json'
      }
    }
    // FormData: 让浏览器自动设置 Content-Type（含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    // /userInfo 是前端权限的唯一数据源，后端未下发 Cache-Control，
    // GET 响应可能被浏览器复用，导致换账号后权限停留在旧值（按钮凭空消失）。
    // 加时间戳参数强制绕过缓存。
    if (config.method === 'get' && config.url && config.url.indexOf('/userInfo') !== -1) {
      config.params = { ...(config.params || {}), _t: Date.now() }
    }
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    const body = response.data
    console.log('[AXIOS] 响应:', response.config.url, '| code:', body?.code, '| data keys:', body?.data ? Object.keys(body.data) : 'null')
    if (body && body.code !== 200) {
      console.log('[AXIOS] code非200，拦截:', body.code)
      Message.error(body.message || '请求失败')
      return Promise.reject(new Error(body.message || '请求失败'))
    }
    // PageResult 解包: {currentPage,perPage,total,lastPage,data} -> {list,total,...}
    if (body && body.data && typeof body.data === 'object' && 'currentPage' in body.data && 'data' in body.data) {
      console.log('[AXIOS] PageResult解包, list长度:', (body.data.data || []).length, ', total:', body.data.total)
      response.data = {
        list: body.data.data || [],
        total: body.data.total || 0,
        currentPage: body.data.currentPage,
        perPage: body.data.perPage,
        lastPage: body.data.lastPage
      }
    } else if (body && Array.isArray(body.data)) {
      console.log('[AXIOS] 数组解包, 长度:', body.data.length)
      response.data = { list: body.data, total: body.data.length }
    } else {
      // 透传业务数据（含 number/string/null/object），避免原始类型仍被包装在 Result 中
      console.log('[AXIOS] 透传 data, type:', typeof body.data)
      response.data = body.data
    }
    console.log('[AXIOS] 最终 response.data:', response.data)
    return response
  },
  error => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        const hash = window.location.hash
        const isSupplierPage = hash.startsWith('#/supplier-login')
          || hash.startsWith('#/supplier-register')
          || hash.startsWith('#/supplier-home')
          || window.location.pathname.startsWith('/supplier-')
        localStorage.removeItem('token')
        localStorage.removeItem('supplier_token')
        if (isSupplierPage) {
          window.location.href = '/supplier-login'
        } else {
          window.location.href = '/admin/#/Login'
        }
      } else {
        const msg = error.response.data && error.response.data.message
        Message.error(msg || '请求失败')
      }
    } else {
      Message.error('网络错误')
    }
    return Promise.reject(error)
  }
)

export default request
